import { render } from "./DimensionList.vue?vue&type=template&id=01e6397e&scoped=true"
import script from "./DimensionList.vue?vue&type=script&lang=js"
export * from "./DimensionList.vue?vue&type=script&lang=js"

import "./DimensionList.vue?vue&type=style&index=0&id=01e6397e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e6397e"]])

export default __exports__